export default {
  items: [
    {
      name: 'Panel de Control',
      url: '/panel-de-control',
      icon: 'icon-speedometer'
    },
    {
      name: 'Archivos',
      url: '/archivos',
      icon: 'icon-folder',
      children: [
        {
          name: 'Seriales',
          url: '/archivos/seriales',
          icon: 'icon-notebook'
        },
        {
          name: 'Libros',
          url: '/archivos/libros',
          icon: 'icon-book-open'
        },
        {
          name: 'Contenidos',
          url: '/archivos/contenidos',
          icon: 'icon-calculator'
        },
        {
          name: 'Instituciones',
          url: '/archivos/instituciones',
          icon: 'icon-graduation'
        },
        {
          name: 'Docentes',
          url: '/archivos/docentes',
          icon: 'icon-eyeglass'
        },
        {
          name: 'Alumnos',
          url: '/archivos/alumnos',
          icon: 'icon-user'
        }
      ]
    },
    {
      name: 'Reportes',
      url: '/reportes',
      icon: 'icon-docs',
      children: [
        {
          name: 'Historial',
          url: '/reportes/historial',
          icon: 'icon-clock'
        }
      ]
    },
    {
      name: 'Seguridad',
      url: '/segurdad',
      icon: 'icon-shield',
      children: [
        {
          name: 'Usuarios',
          url: '/seguridad/usuarios',
          icon: 'icon-user'
        },
        {
          name: 'Grupos',
          url: '/seguridad/grupos',
          icon: 'icon-people'
        },
        {
          name: 'Permisos',
          url: '/seguridad/permisos',
          icon: 'icon-check'
        }
      ]
    },
    {
      name: 'Configuración',
      url: '/configuracion',
      icon: 'icon-equalizer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js